import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as sessionActions from "../../../actions/sessionActions";
import { throwException } from "../../../actions/exceptionActions";
import SporttakOverzichtForm from "./SporttakOverzichtForm";
import SporttakToevoegenForm from "./SporttakkenToevoegenForm";
import redirector from "../../../util/redirector";
import SporttakOverzichtPageHelper from "./SporttakOverzichtPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import ConfirmModal from "../../common/ConfirmModal";

class SporttakkenOverzichtPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            transactieId: '',
            sportclubId: '',
            models: [],
            original: {
                models: [],
                checkedSporttakken: [],
                indeterminateSporttakken: []
            },
            hasUnsavedChanges: false,
            shouldScrollToFirstError: false,
            validationMessageType: '',
            errors: {},
            undoButtonDisabled: true,
            checkedSporttakken: [],
            indeterminateSporttakken: [],
            level: -1,
            addSporttakActive: false,
            filter: '',
            searchresults: [],
            disabledSportakken: [],
            stateBefore: {},
            somethingChanged: false,
            hasUnsavedChangesOnAdd: false,
            totalSearchResults: -1,
            sporttakFilterHasFocus: true
        };

        this.pageHelper = new SporttakOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        this.props.setHasUnsavedChanges(false);
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnSave = () => this.pageHelper.save();

    handleOnChange = (event) => this.pageHelper.change(event);

    handleOnUndo = () => this.pageHelper.undo();

    handleOnIncreaseLevel = (currentLevel) => this.pageHelper.increaseLevel(currentLevel);

    handleOnOpenAdd = () => this.pageHelper.openAdd();

    handleOnChangeAdd = (event) => this.pageHelper.changeAdd(event);

    handleOnContinueAdd = () => this.pageHelper.continueAdd();

    handleOnCancelAdd = () => this.pageHelper.cancelAdd();

    handleOnSearch = () => this.pageHelper.search();

    handleOnChangeFilter = (event) => this.pageHelper.changeFilter(event);

    handleOnCancelUnsavedChanges = () => this.pageHelper.cancelUnsavedChanges();

    handleOnConfirmUnsavedChanges = () => this.pageHelper.confirmUnsavedChanges();

    render() {
        const {
            models,
            checkedSporttakken,
            level,
            addSporttakActive,
            filter,
            searchresults,
            indeterminateSporttakken,
            hasUnsavedChangesOnAdd,
            totalSearchResults,
            sporttakFilterHasFocus
        } = this.state;

        const disabled = this.props.disabled;

        return (
            addSporttakActive ?
                <Fragment>
                    <ConfirmModal
                        hookToTop={false}
                        isOpen={hasUnsavedChangesOnAdd}
                        title="Je hebt jouw selecties niet bevestigd. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?"
                        mainText="Opgelet: niet bewaarde wijzigingen!"
                        confirmAction={this.handleOnConfirmUnsavedChanges}
                        confirmText="Ga verder"
                        cancelText="Terug"
                        cancelAction={this.handleOnCancelUnsavedChanges} />
                    <SporttakToevoegenForm
                        models={models}
                        searchResults={searchresults}
                        onChange={this.handleOnChangeAdd}
                        onContinueAdd={this.handleOnContinueAdd}
                        onCancelAdd={this.handleOnCancelAdd}
                        checkedSporttakken={checkedSporttakken}
                        onIncreaseLevel={this.handleOnIncreaseLevel}
                        level={level}
                        filter={filter}
                        onSearch={this.handleOnSearch}
                        onChangeFilter={this.handleOnChangeFilter}
                        indeterminateSporttakken={indeterminateSporttakken}
                        totalSearchResults={totalSearchResults}
                        sporttakFilterHasFocus={sporttakFilterHasFocus}
                    />
                </Fragment>
                :
                <SporttakOverzichtForm
                    models={models}
                    onChange={this.handleOnChange}
                    onUndo={this.handleOnUndo}
                    undoButtonDisabled={this.state.undoButtonDisabled}
                    onSave={this.handleOnSave}
                    checkedSporttakken={checkedSporttakken}
                    onIncreaseLevel={this.handleOnIncreaseLevel}
                    indeterminateSporttakken={indeterminateSporttakken}
                    level={level}
                    onAdd={this.handleOnOpenAdd}
                    disabled={disabled}
                />
        );
    }
}

SporttakkenOverzichtPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        federatieOndernemingsnummer: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.ondernemingsnummer: null,
        federatieId: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.id: null,
        gebruikersnaam: state.security.currentUser,
        transactieId: state.session.activeTransactionId,
        sportclubId: state.session.activeSportclubId,
        disabled: state.session.readOnly,
        isNew: state.session.isNew
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadSportOrganisatieSporttakkenPageLayout: bindActionCreators(layoutActions.loadSportOrganisatieSporttakkenPageLayout, dispatch),
        loadFederatieSporttakkenToevoegenPageLayout: bindActionCreators(layoutActions.loadFederatieSporttakkenToevoegenPageLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        setActiveTransaction: bindActionCreators(sessionActions.setActiveTransactionId, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SporttakkenOverzichtPage);